import { render, staticRenderFns } from "./RadioList.vue?vue&type=template&id=27511973&"
import script from "./RadioList.vue?vue&type=script&lang=js&"
export * from "./RadioList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports